export default __webpack_public_path__ + "images/623964e9f28988e9fe32704379c692f1-metal_music_small.webp";